import { lazy } from 'react'
import PageNotFound from 'routes/Components/PageNotFound'
import Dashboard from 'modules/Dashboard/Container/index'
import Onboarding from 'modules/Onboarding/Container/index'
import RegisterSuccessfulPage from 'modules/Onboarding/Components/RegisterSuccessful/RegisterSuccessfulPage'
import Institutes from 'modules/Institutes/Container/index'
import Users from 'modules/User/Container/index'
import Settings from 'modules/Settings/Container/index'
import Corporate from 'modules/Onboarding/Partials/Corporates/Register/Container'
import Institute from 'modules/Onboarding/Partials/Institutes/Register/Container'
import UserView from 'modules/User/Partials/UsersView/Container/index'
import Reports from 'modules/Reports/Container/index'
import InstituteInfoTable from 'modules/Reports/Partials/Institutes/Container/InstituteInfoIndex.js'
import EmpanelledInfoTable from 'modules/Reports/Partials/Corporates/Container/index'
import Top10Index from 'modules/Reports/Partials/Corporates/Container/TopBottomCorporateIndex'
import InstEmpanelledTable from 'modules/Reports/Partials/Institutes/Container/index.js'
import Top10InstituteInfoTable from 'modules/Reports/Partials/Institutes/Container/TopInstituteList.js'
import StudentListOfData from 'modules/Reports/Partials/Students/Container/ListOfStudentTableIndex'
import StudentsCourseWiseTable from 'modules/Reports/Partials/Students/Container/StudentCourseBaseIndex.js'
import ListOfStudentsPlacedTable from 'modules/Reports/Partials/Students/Container/StudentPlacedTableIndex.js'
import StudentSkillWiseData from 'modules/Reports/Partials/Students/Container/StudentSkillWiseDetails.js'
import ManageProfile from 'modules/ManageProfile/index'
import SystemsConfig from 'modules/Systemconfig/index'
import GeneralSysConfig from 'modules/Systemconfig/Partials/GeneralTableSettings/Container/index'
import CorporateSysConfig from 'modules/Systemconfig/Partials/CorporateSettings/Container/index'
import Corporates from 'modules/Corporates/Container/index'
import Courses from 'modules/Courses/Container/index'
import AssessmentContainer from 'modules/Assessment/Container/index'
import CreateAssessment from 'modules/Assessment/Partials/CreateAssessment'
import AssignSubscription from 'modules/Assessment/Partials/AssignSubscription'
import CollegeTableMain from 'modules/Assessment/Partials/CollegeTable/CollegeTableMain'
import ReviewAssessmentsList from 'modules/Assessment/Partials/ReviewAssessmentsList'
import AssessmentSetReview from 'modules/Assessment/Partials/AssessmentSetReview'
import AssignmentActivityPage from 'modules/Assessment/Partials/AssignmentActivity/AssignmentActivityPage'
import AssignmentActivityList from 'modules/Assessment/Partials/AssignmentActivity/AssignmentActivityList'

import InstituteSettings from 'modules/Systemconfig/Partials/InstituteSettings/Container/index'
import MyLocationSettings from 'modules/Systemconfig/Partials/MyLocationSettings/Container/index'
import BillingSysConfig from 'modules/Systemconfig/Partials/BillingSettings/Container/index'
import EventCatalogue from 'modules/EventCatalogue/Container/index'
import AuditLog from 'modules/AuditLog/Container/index'
import PermissionSettings from 'modules/Systemconfig/Partials/PermissionSettings/Container/index'
import RankingAlgorithm from 'modules/RankingAlgorithm/Container/index.js'
import Analytics from 'modules/Analytics/Container/index'
import CandidateMetrics from 'modules/CandidateMetrics/Container/index'
import CandidatesRaw from 'modules/CandidatesRaw/index'
import CandidateMetricDetails from 'modules/CandidateMetricDetails/index'
import AdminDashboard from 'modules/AdminDashboard/Container/index'
import MetaDashboard from 'modules/MetaDashboard/Container/index'
import AIInterviewReport from 'modules/AIInterview/AIInterviewReport'

export const authenticatedWithNav = [
  {
    routePath: '/ai-interview/report/:sessionId',
    Component: AIInterviewReport,
  },
  {
    routePath: '/dashboard',
    Component: Dashboard,
  },
  {
    routePath: '/audit-log',
    Component: AuditLog,
    navTitle: 'Audit Log',
  },
  {
    routePath: '/dashboards',
    Component: Analytics,
  },
  {
    routePath: '/dashboards/candidate-metrics',
    Component: CandidateMetrics,
    navTitle: 'Candidate Metrics',
  },
  {
    routePath: '/dashboards/candidates-raw',
    Component: CandidatesRaw,
    navTitle: 'Candidates Raw',
  },
  {
    routePath: '/dashboards/candidate-metric-details',
    Component: CandidateMetricDetails,
    navTitle: 'Candidate Metric Details',
  },
  {
    routePath: '/admin-dashboard',
    Component: AdminDashboard,
    navTitle: 'Admin Dashboard',
  },
  {
    routePath: '/meta-dashboard',
    Component: MetaDashboard,
    navTitle: 'Meta Dashboard',
  },
  {
    routePath: '/rankingAlgorithm',
    Component: RankingAlgorithm,
    navTitle: 'Ranking Algorithm',
  },
  {
    routePath: '/onboarding',
    Component: Onboarding,
    navTitle: 'Onboarding',
  },
  {
    routePath: '/onboarding/corporate',
    Component: Corporate,
  },
  {
    routePath: '/onboarding/institute',
    Component: Institute,
  },
  {
    routePath: '/onboarding/corporate/registeredSuccessfully',
    Component: RegisterSuccessfulPage,
  },
  {
    routePath: '/corporates',
    Component: Corporates,
  },
  {
    routePath: '/institutes',
    Component: Institutes,
    navTitle: 'Institutes',
  },
  {
    routePath: '/reports/corporate',
    Component: Reports,
  },
  {
    routePath: '/reports/corporate/empanelledinfotable',
    Component: EmpanelledInfoTable,
  },
  {
    routePath: '/reports/corporate/top10index',
    Component: Top10Index,
  },
  {
    routePath: '/reports/institute',
    Component: InstituteInfoTable,
  },
  {
    routePath: '/reports/institute/empanelledinfotable',
    Component: InstEmpanelledTable,
  },
  {
    routePath: '/reports/institute/top10index',
    Component: Top10InstituteInfoTable,
  },
  {
    routePath: '/reports/students',
    Component: StudentListOfData,
  },
  {
    routePath: '/reports/students/studentplacedscoursewise',
    Component: StudentsCourseWiseTable,
  },
  {
    routePath: '/reports/students/listofstudentspalced',
    Component: ListOfStudentsPlacedTable,
  },
  {
    routePath: '/reports/students/studentskillwise',
    Component: StudentSkillWiseData,
  },
  {
    routePath: '/users',
    Component: Users,
    navTitle: 'Users',
  },
  {
    routePath: '/users/:id',
    Component: UserView,
  },
  {
    routePath: '/manageprofile',
    Component: ManageProfile,
  },
  {
    routePath: '/systemConfig',
    Component: SystemsConfig,
  },
  {
    routePath: '/systemConfig/GeneralTableSettings/:GeneralCard/:id',
    Component: GeneralSysConfig,
  },
  {
    routePath: '/systemConfig/corporateSettings',
    Component: CorporateSysConfig,
  },
  {
    routePath: '/settings',
    Component: Settings,
    navTitle: 'Settings',
  },
  {
    routePath: '/systemConfig/instituteSettings/:institueCard/:id',
    Component: InstituteSettings,
  },
  {
    routePath: '/systemConfig/permissionSettings/:institueCard/:id',
    Component: PermissionSettings,
  },
  {
    routePath: '/systemConfig/locationSettings/:locationCard/:id',
    Component: MyLocationSettings,
  },
  {
    routePath: '/systemConfig/billingSettings',
    Component: BillingSysConfig,
  },
  {
    routePath: '/coursemapping',
    Component: Courses,
    navTitle: 'Courses',
  },
  {
    routePath: '/eventcatalogue',
    Component: EventCatalogue,
    navTitle: 'Event Catalogue',
  },
  {
    routePath: '/assessment',
    Component: AssessmentContainer,
    navTitle: 'Assessment',
  },
  {
    routePath: '/assessment/create',
    Component: CreateAssessment,
  },
  {
    routePath: '/assessment/reviews',
    Component: ReviewAssessmentsList,
  },
  {
    routePath: '/assessment/review/:groupId',
    Component: AssessmentSetReview,
  },
  {
    routePath: '/assessment/activity',
    Component: AssignmentActivityList,
  },
  {
    routePath: '/assessment/activity/job/:jobId',
    Component: AssignmentActivityPage,
  },
  {
    routePath: '/assessment/activity/schedule/:scheduleId',
    Component: AssignmentActivityPage,
  },
  {
    routePath: '/assessmentAssignSubscription',
    Component: AssignSubscription,
  },
  {
    routePath: '/assessmentAssignSubscription/institute/:id',
    Component: AssignSubscription,
  },
  {
    routePath: '/assessmentAssignSubscription/corporate/:id',
    Component: AssignSubscription,
  },
  {
    routePath: '/assessmentAccess',
    Component: CollegeTableMain,
  },
]

export const authenticatedWithoutNav = [
  {
    routePath: '/onboarding/corporate/:corporateId',
    Component: Corporate,
  },
  {
    routePath: '/onboarding/institute/:instituteId',
    Component: Institute,
  },
  {
    routePath: '/onboarding/registeredSuccessfully',
    Component: RegisterSuccessfulPage,
  },
  {
    routePath: '*',
    Component: PageNotFound,
  },
]
